export default __webpack_public_path__ + "static/media/id.033289d4.svg";